import http from './http'

export default {
    prospectos() {
        return http.get('onisvida/prospectos')
    },

    addComment(prospecto, contenido) {
        return http.post(`onisvida/prospectos/${prospecto}/comentarios`, {
            contenido
        })
    },
}